module.exports = __webpack_public_path__ + "static/img/Picture1.4ef8d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Picture1.png
// module id = PlJg
// module chunks = 1